import React, { useEffect } from "react"
import { navigate } from "gatsby"

const IndexPage = () => {
    useEffect(() => {
        const ids = [
            "anna-westbrook",
            "ava-amedi",
            "koulla-roussos",
            "martina-copley",
            "melody-ellis",
            "pia-ednie-brown",
            "sholto-buck",
            "shu-ling-chua",
            "yoko-akama",
            "zara-sigglekow",
        ]
        const id = ids[Math.floor(Math.random() * ids.length)]
        navigate(`/piece/${id}`)
    }, [])

    return <div></div>
}

export default IndexPage
